import { useLayoutEffect } from 'react';

export function useSidebarScale({
  navBottomRef,
  navContentRef,
  navLogoRef,
  profile,
  setNavBoxHeight,
  setNavScale,
  sidebarCollapsed,
}) {
  useLayoutEffect(() => {
    const logo = navLogoRef.current;
    const bottom = navBottomRef.current;
    const content = navContentRef.current;
    if (!logo || !bottom || !content) return;
    const MIN_SCALE = 0.55;
    const recompute = () => {
      const appHeight = Math.max(window.innerHeight, 640);
      const available =
        appHeight - logo.getBoundingClientRect().height - bottom.getBoundingClientRect().height;
      const natural = content.scrollHeight;
      if (!available || !natural) return;
      const s = Math.max(MIN_SCALE, Math.min(1, available / natural));
      setNavScale((prev) => (Math.abs(prev - s) > 0.005 ? s : prev));
      setNavBoxHeight((prev) => (Math.abs((prev || 0) - available) > 0.5 ? available : prev));
    };
    recompute();
    if (document.fonts?.ready) document.fonts.ready.then(recompute).catch(() => {});
    const t = setTimeout(recompute, 300);
    window.addEventListener('resize', recompute);
    return () => {
      clearTimeout(t);
      window.removeEventListener('resize', recompute);
    };
  }, [profile?.role, sidebarCollapsed]);
}
